export default __webpack_public_path__ + "static/media/s3.bf44b861.png";